import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import {
  deleteData,
  findData,
  recordFiltering,
} from '~/store/modules/gerencias/actions';

import Form from './form';

function Gerencias() {
  const redux = useSelector((state) => state.gerencias);

  // Options
  const status = useMemo(
    () => [
      { label: 'L', value: t('s.geral.opcoes.liberado') },
      { label: 'B', value: t('s.geral.opcoes.bloqueado') },
      { label: 'C', value: t('s.geral.opcoes.cancelado') },
    ],
    []
  );

  // Header tabela
  const header = useMemo(
    () => [
      {
        id: 'idgerencia',
        label: t('s.cadastro.gerencia.idgerencia'),
        filter: { type: 'text' },
      },
      {
        id: 'nomegerencia',
        label: t('s.cadastro.gerencia.nomegerencia'),
        filter: { type: 'text' },
      },
      {
        id: 'statusgerencia',
        label: t('s.cadastro.gerencia.statusgerencia'),
        formatted: (value) => status.find((s) => s.label === value).value || '',
        filter: { type: 'select', options: status },
      },
    ],
    [status]
  );

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findData}
      remove={deleteData}
      form={Form}
      keys="idgerencia"
      detach="idgerencia"
    />
  );
}

export default Gerencias;
